const inkeep_ai_bot = {
    intro_message: 'Oi, sou o Logto AI!\n\nSou um assistente de IA treinado em documentação, artigos de ajuda e outros conteúdos.\n\nPergunte-me qualquer coisa sobre `Logto`.',
    chat_placeholder: 'Pergunte ao Logto AI sua dúvida para um guia passo a passo',
    disclaimer_label: 'Aviso legal do Logto AI',
    disclaimer_tooltip: 'As respostas são geradas por IA e podem necessitar de verificação.',
    example_questions_label: 'Perguntas de exemplo',
    example_questions: [
        'Guia de início rápido para configuração do Logto',
        'Configurar arquitetura multi-tenancy',
        'Como integrar o perfil do usuário?',
    ],
    stop: 'Parar',
    clear: 'Começar de novo',
    get_help: 'Obter ajuda',
    copy_chat: 'Copiar',
    ask_ai_label: 'Perguntar à IA',
    contact: 'Contato',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
